import { Form, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import MUploadImage from "../../../../component/UploadImage";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { Brand, BrandUI } from "../entity/brand.model";
import { brandService } from "../service/brand.service";
import { Entity } from "../../shared/shared.model";
import { entityService } from "../../shared/service/entity.service";

export default function EditBrand() {
  const { dispatch } = useContext(SpinContext);
  const { Option } = Select;
  let { brandId } = useParams();
  let navigate = useNavigate();
  const [brand, setBrand] = useState<BrandUI>();
  const [brands, setBrands] = useState<Entity[]>([]);

  useEffect(() => {
    if (brandId) {
      dispatch({ type: spinActions.BLOCK });

      brandService
        .getBrand(brandId)
        .then((_brand: Brand) => {
          dispatch({ type: spinActions.UNBLOCK });
          helper.getImage("/public" + "/" + _brand.imagePath).then((file) => {
            setBrand({
              ..._brand,
              file: file,
            });
          });
        })

        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    } else {
      setBrand({
        uuid: "",
        imagePath: "",
        brand1Cuuid: "",
      });
    }

    entityService.getBrands().then((_brands) => {
      _brands.sort((a, b) => a.name.localeCompare(b.name));
      setBrands(_brands);
    });
    return () => {
      setBrands([]);

      setBrand(undefined);
    };
  }, [brandId]);

  const onFinish = async (values: BrandUI) => {
    const formData = new FormData();
    formData.append("file", values.file);
    const brandDto = {
      brand1Cuuid: values.brand1Cuuid,
      brand1Cname: brands.find((b) => b.uuid === values.brand1Cuuid)?.name,
      ...(brandId && { uuid: brandId }),
    };

    formData.append(
      "brandDto",
      new Blob([JSON.stringify(brandDto)], { type: "application/json" })
    );
    if (brand) {
      try {
        if (brandId) {
          await brandService.editBrand(formData);
        } else {
          await brandService.addBrand(formData);
        }
        dialog.success("Брэнд амжилттай шинэчлэгдлээ.");
        navigate("/brand");
      } catch (e) {
        console.error(e);

        return;
      }
    }
  };
  console.log("default value of brand", brand);
  return (
    <>
      <MPageHeader crumbs={["Брэнд", brand?.uuid ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">
              {brandId ? "Брэнд засах" : "Брэнд нэмэх"}{" "}
            </h5>
          </div>
          <div className="card-body">
            {brand && (
              <fieldset disabled={!helper.hasRoles(["customer-full"])}>
                <Form initialValues={brand} onFinish={onFinish}>
                  <div className="form-group">
                    <label>
                      Зураг<span className="text-danger">*</span>
                    </label>

                    <Form.Item
                      name="file"
                      rules={[
                        {
                          required: true,
                          message: "Зураг оруулна уу.",
                        },
                      ]}
                    >
                      <MUploadImage
                        disabled={!helper.hasRoles(["customer-full"])}
                      />
                    </Form.Item>
                  </div>
                  <div className="form-group">
                    <label>UUID</label>
                    <Form.Item name="uuid">
                      <Input readOnly={true} className="form-control" />
                    </Form.Item>
                  </div>
                  <div className="form-group">
                    <label>Брэнд</label>
                    <Form.Item
                      name="brand1Cuuid"
                      rules={[
                        {
                          required: true,
                          message: "Брэндийг сонгоно уу.",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Брэнд сонгох"
                        disabled={!helper.hasRoles(["customer-full"] ) || brandId !== undefined}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option!.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {brands.map((brand) => (
                          <Option value={brand.uuid} key={brand.uuid}>
                            {brand.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <Authorization roles={["customer-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
